import { isAnyOf } from "@reduxjs/toolkit";

import { updateYardVisitIsPaidStatusThunk } from "../../reducers/collectionYardsVisitsDetailReducer";
import {
  getCollectionYardVisitEventsSummaryThunk,
  getCollectionYardVisitEventsThunk,
  removeCollectionYardVisitEventsFilter,
  setCollectionYardVisitEventsFilter,
  setCollectionYardVisitEventsOrdering,
  setCollectionYardVisitEventsPagination,
  setCollectionYardVisitEventsVisitId,
} from "../../reducers/collectionYardVisitEventsReducer";
import { COLLECTION_POINT_VISIT_PAGE_PATH } from "../routes";
import { startAppListening } from "./listenerMiddleware";

export const collectionYardVisitEventsListener = (): void => {
  startAppListening({
    actionCreator: setCollectionYardVisitEventsVisitId,
    effect: async (action, { dispatch }) => {
      const visitId = action.payload;
      if (!visitId) return;
      dispatch(getCollectionYardVisitEventsSummaryThunk(visitId));
      dispatch(getCollectionYardVisitEventsThunk(visitId));
    },
  });

  startAppListening({
    matcher: isAnyOf(
      setCollectionYardVisitEventsOrdering,
      setCollectionYardVisitEventsFilter,
      setCollectionYardVisitEventsPagination,
      removeCollectionYardVisitEventsFilter
    ),
    effect: async (_, { dispatch, getState }) => {
      const visitId = getState().collectionYardVisitEvents.visitId;
      if (visitId) {
        dispatch(getCollectionYardVisitEventsThunk(visitId));
      }
    },
  });

  startAppListening({
    matcher: isAnyOf(updateYardVisitIsPaidStatusThunk.fulfilled),
    effect: async (action, { dispatch }) => {
      const visitId = action.payload.collection_yard_visit_id;
      const pathname = location.pathname;
      switch (pathname) {
        case COLLECTION_POINT_VISIT_PAGE_PATH:
          dispatch(getCollectionYardVisitEventsSummaryThunk(visitId));
          break;

        default:
          break;
      }
    },
  });
};
